import i18n from '@/i18n';

import type {
	FollowingBaseInput,
	FollowingLineGeneratorResult,
} from '@/components/following/types';

import { createTextSegment } from './segmentFactory';

export const INTERVIEW_REPORT_LINE_ICON = 'cal-user';

export interface InterviewReportFollowingInput extends FollowingBaseInput {
	summary?: string;
}

/**
 * Builds a following line for `interview_report_created` profile history events.
 * Visually aligned with notes (icon + label + expandable content). The interview id is
 * only known from the activity envelope, so `interviewContext` is attached later by
 * `activityToFollowingMapper`; a dedicated icon keeps the Suivi "Notes" filter from
 * swallowing interview entries.
 */
export const buildFollowingLineInterviewReport = (
	input: InterviewReportFollowingInput
): FollowingLineGeneratorResult => {
	const trimmedSummary = input.summary?.trim();
	return {
		icon: INTERVIEW_REPORT_LINE_ICON,
		segments: [
			createTextSegment(
				i18n.global.t(
					'following.labels.profileHistoryLogger.interviewReportAdded'
				)
			),
		],
		detail: input.detail,
		content: trimmedSummary ? trimmedSummary : undefined,
	};
};
